export enum eSurveyFormQuestionTypeId {
    TITLE = 1,
    SELECT_SINGLE_RADIO = 2,
    SELECT_SINGLE_COMBOBOX = 3,//để sau
    SELECT_MULTIPLE_CHECKLIST = 4,
    SELECT_MULTIPLE_DROPDOWN = 5,//để sau
    TEXT_INPUT=6,
    DATE_BOX = 7,
}